import React, { useState } from 'react';
import Hero from './section/hero';
import Intro from './section/intro';
import Price from './section/price';
import Photo from './section/photo';
import Roller from './section/roller';
import Detail from './section/detail';
import Review from './section/review';
// import Waitlist from './section/waitlist';
import Newsletter from './section/newsletter';
import FAQ from './section/faq';
import Cycle from './section/cycle';
import Footer from './section/footer';
import Splash from './section/splash';
import photo1 from './assets/photo-1.png';
import photo2 from './assets/photo-2.png';
import Challenge from './section/challenge';
import Download from './section/download';
import NewChallenge from './section/newChallenge';
import DayOne from './section/dayOne';

const photoWording = {
  photo1: {
    title: ['Momentum is stronger', 'than motivation.'],
    description: [
      'When you rely on motivation, you stop when it fades.',
      'When you build momentum, you keep going.',
    ],
  },
  photo2: {
    title: ["Show up today. That's all", 'it takes to move forward.'],
    description: [
      "You don't have to be perfect - just present.",
      'One action, one choice, one win at a time.',
    ],
  },
};

const heroSource = 'https://static-resource.thechamps.app/vod/start.mp4';
const heroCopy = [
  'One small win at a time.',
  'TheChamps helps you build momentum.',
];

const App = () => {
  const [showSplash, setShowSplash] = useState(true);

  const handleSplashFinish = () => {
    setShowSplash(false);
    // Restore scroll when splash screen is done
    document.body.style.overflow = 'auto';
  };

  // Prevent scroll while splash screen is showing
  if (showSplash) {
    document.body.style.overflow = 'hidden';
  }

  return (
    <>
      {showSplash && <Splash onFinish={handleSplashFinish} />}
      <div className='min-h-dvh'>
        <Hero
          source={heroSource}
          copy={heroCopy}
        />
        {/* <DayOne /> */}
        {/* <NewChallenge /> */}
        <Challenge />
        <Intro />
        <Download />
        <Price />
        <Photo
          imgUrl={photo1}
          wording={photoWording.photo1}
        />
        <Roller />
        <Detail />
        <Cycle />
        <Photo
          imgUrl={photo2}
          wording={photoWording.photo2}
        />
        <Price />
        <Review />
        <Newsletter />
        <FAQ />
        <Footer />
      </div>
    </>
  );
};

export default App;
